import CardBody from './CardBody'
import CardFooter from './CardFooter'
import CardHeader from './CardHeader'
import CardWrapper from './CardWrapper'

export default {
  Body: CardBody,
  Footer: CardFooter,
  Header: CardHeader,
  Wrapper: CardWrapper,
}
